<mat-card class="mb-5 p-0 default">
  <mat-progress-bar [mode]="loading ? 'indeterminate' : 'determinate'"></mat-progress-bar>

  <mat-card-content *ngIf="files.length === 0; else filesEl" class="p-0">
    <div
      class="dropzone"
      [ngClass]="[dragover ? 'dragover': '', loading ? 'loading' : '']"
      (click)="onDropzoneClick()"
    >
      <div class="dropzone-inner">
        <mat-icon class="dropzone-icon">
          drive_folder_upload
        </mat-icon>
        <div class="dropzone-content">
          <ng-content></ng-content>
        </div>
      </div>
    </div>
  </mat-card-content>

  <ng-template #filesEl>
    <mat-card-title>
      <span>{{ 'dropzone.title' | translate }}</span>
    </mat-card-title>

    <mat-card-content>
      <table mat-table [dataSource]="files" class="mb-5">
        <ng-container matColumnDef="select">
          <th mat-header-cell *matHeaderCellDef>
            <mat-checkbox
              (change)="toggleSelectAll()"
              [checked]="files.length === selectedFiles.length"
              [disabled]="loading"
              [indeterminate]="selectedFiles.length > 0 && selectedFiles.length < files.length"
            ></mat-checkbox>
          </th>
          <td mat-cell *matCellDef="let file">
            <mat-checkbox
              [disabled]="loading"
              (change)="toggleSelect(file)"
              [checked]="isSelected(file)"
            ></mat-checkbox>
          </td>
        </ng-container>
        <ng-container matColumnDef="name">
          <th mat-header-cell *matHeaderCellDef>Name</th>
          <td mat-cell *matCellDef="let file">{{ file.name }}</td>
        </ng-container>

        <ng-container matColumnDef="size">
          <th mat-header-cell *matHeaderCellDef>Size</th>
          <td mat-cell *matCellDef="let file">{{ file.size | filesize }}</td>
        </ng-container>

        <ng-container matColumnDef="type">
          <th mat-header-cell *matHeaderCellDef>Type</th>
          <td mat-cell *matCellDef="let file">{{ file.type }}</td>
        </ng-container>

        <ng-container matColumnDef="actions">
          <th mat-header-cell *matHeaderCellDef style="width: 100px">Actions</th>
          <td mat-cell *matCellDef="let file" style="width: 100px">
            <button mat-icon-button (click)="removeFile(file)">
              <mat-icon>delete</mat-icon>
            </button>
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="columns"></tr>
        <tr mat-row *matRowDef="let row; columns: columns"></tr>
      </table>
      <div fxLayout="row" fxLayoutAlign="center center">
        <button
          mat-fab
          extended
          color="primary"
          [disabled]="selectedFiles.length === 0 || loading"
          (click)="uploadFiles.emit(selectedFiles)"
        >
          <mat-icon>cloud_upload</mat-icon>
          {{ 'dropzone.upload-button' | translate }}
        </button>
      </div>
    </mat-card-content>
  </ng-template>
</mat-card>
